export const DISPLAY_NOTIFICATION = '@notification/DISPLAY_NOTIFICATION';
export const DISMISS_NOTIFICATION = '@notification/DISMISS_NOTIFICATION';

export interface DisplayNotificationAction {
  readonly type: typeof DISPLAY_NOTIFICATION;
  payload: {
    message: string;
  };
}

export interface DismissNotificationAction {
  readonly type: typeof DISMISS_NOTIFICATION;
}

export interface Notification {
  message: string;
}

export type NotificationsState = Notification[];

export type NotificationActionTypes = DisplayNotificationAction | DismissNotificationAction;
